import React from 'react'


const Info : React.FC = () => (
  <>
  </>
)

export default Info
